<template>
  <div class="modal fade" id="modalRemoveItemInOrder" tabindex="-1" aria-labelledby="modalRemoveItemInOrderLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="modalRemoveItemInOrderLabel">{{ $t('orderItemRemove.removeItem') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="text-center">
            <p>{{ $t('orderItemRemove.remove') }}<b>{{product.title}}</b> ?</p>
            <input v-model="commentForChange" type="text" class="form-control" id="commentForChangeOrder" :placeholder="$t('orderItemRemove.comment')">
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{ $t('orderItemRemove.no') }}</button>
          <button
              @click="removeItemInOrder(product.index)"
              :disabled="emptyComment"
              data-bs-dismiss="modal"
              type="button" class="btn btn-danger">{{ $t('orderItemRemove.yes') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "OrderItemRemove",
  props: ['product'],
  data() {
    return {
      commentForChange: '',
    }
  },
  computed: {
    emptyComment() {
      if (this.commentForChange === '') {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    removeItemInOrder(index) {
      let restId = this.$route.params.id
      let orderId = this.$route.params.orderId
      let requestBody = {
        'menu_items': [{
          'action': 'REMOVE',
          'item': {'index': index}
        }],
        'comment': this.commentForChange
      }
      let payload = { restId, orderId, requestBody }
      this.$store.dispatch('changeMenuItemInOrder', payload)
      this.commentForChange = ''
    },
  }
}
</script>

<style scoped>

</style>